import { render } from "./PasswordResetEmail.vue?vue&type=template&id=64bcdf9d&ts=true"
import script from "./PasswordResetEmail.vue?vue&type=script&lang=ts"
export * from "./PasswordResetEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__